import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../Services/auth.service';
import { GeneralSettingsService } from '../../Services/general-settings.service';
import { MemberService } from '../../Services/member.service';



@Component({
  selector: 'app-member-mass-payed',
  template: require('./member-mass-payed.component.html'),
  styles: [require('./member-mass-payed.component.css')]
})
export class MemberMassPayedComponent implements OnInit {
  members: any[] = [];
  loading: boolean = false;
  nameSearchString: string = '';
  searched_members: any[] = [];
  saved_list:number[]=[];
  firstnames: any[] = [];
  lastnames: any[] = [];

  discounts: any[]=[];
  membershipFee:number=0;
  MembershipFeeText:string="";

  showOnlyNonPayed: boolean = false;
  payedMembersCount: number = 0;
  selected_members:any[] = [];

  constructor(
    private memberService: MemberService, 
    private generalSettingsService: GeneralSettingsService,
    private auth: AuthService
    ) { }

  ngOnInit() {
    this.loadAll()
  }

  loadAll(){
    this.selected_members.length = 0;
    this.saved_list = [];
    this.showOnlyNonPayed = false;
    this.loadSubscriptionFee();
    this.getAllMembers();
  }

  getAllMembers(){
    this.loading = true;
    this.memberService.getMembers().subscribe (res => {
      this.members = [];
      this.members = res;
      // var x:any =  this.doCountOfSubscribedMembers()
      
      // this.selectedMembersCount = x.membersCount;
      this.members.forEach(m => {
        
        m.MembershipFeeText = `${this.membershipFee} - ${m.memberDiscount.amountMembership} = ${this.membershipFee - m.memberDiscount.amountMembership}`
      });
      this.payedMembersCount = this.processPayedMembers();
      this.searched_members = this.members
      this.loading = false;
    })
  }

  loadSubscriptionFee(){
    this.generalSettingsService.getSubscriptionFee().subscribe( (res:any)=>{
      if (res.status == 200){
        this.membershipFee = res.value.subscriptionFee;
      }
    })
  }

  searchName(){
    if (this.nameSearchString.length > 0){
      this.firstnames = this.members.filter( a => a.firstName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.lastnames = this.members.filter( a => a.lastName.toLowerCase().indexOf(this.nameSearchString.toLowerCase()) > -1) ;
      this.searched_members = this.firstnames.concat(this.lastnames);
    }else{
      this.searched_members = this.members
    }
  }

  clearSearch(){
    this.nameSearchString = '';
    this.searchName();
  }

  showRow(hasPayedMemberShip: boolean){
    if (this.showOnlyNonPayed && !hasPayedMemberShip ) return true;
    else if (!this.showOnlyNonPayed) return true;
    return true;
  }

  checkboxPayedClicked(id: any){
    // console.log("id: ",id);
    
    if (this.selected_members.find( x => x.id == id)){
      var item = this.selected_members.filter( x => x.id == id)[0];
      var index = this.selected_members.indexOf( item);
      if (index > -1) {
        this.selected_members.splice(index, 1);
        item.hasPayedMemberShip = !item.hasPayedMemberShip;       
        this.selected_members.push(item);
      }
    }else{
      item = {id:id,hasPayedMemberShip:true}
      this.selected_members.push(item);
    }
    // console.log("Sending to change payment: ",item);
    
    this.memberService.changeMemberShipPayment(item.id, item.hasPayedMemberShip).subscribe( (res:any)=>{
      if (res.status == 200){
        // console.log(res);
        var index = this.saved_list.findIndex( sl => sl == res.value.memberId )
        const el = document.getElementById('check'+id)
        if (index == -1){
          this.saved_list.push(res.value.memberId);
        }
        
        if (el !== null){
          el.classList.remove('hidden');
          el.classList.add('show-saved-fading');
          el.addEventListener('animationend', function() {
            el.classList.add('hidden');
            el.classList.remove('show-saved-fading');
          })
        }

        var item = this.members.find( x => x.id == id)
        if (item !==null){
          item.hasPayedMemberShip = res.value.hasPayedMemberShip;
        }

        this.payedMembersCount = this.processPayedMembers();
      }
    })

    
    // var x:any =  this.doCountOfSubscribedMembers()
    
    // this.selectedMembersCount = x.membersCount;
    // this.safeMemberScubscriptions();
  }


  hasPayed(id:any){  
    var item = this.selected_members.find( x => x.memberId == id)
    if (item){
      return item.hasPayedMemberShip;
    }
    else{
      return false
    }
  }

  processPayedMembers(){
    var membersCount  = 0;
    this.members.forEach(element => {
      if (element.hasPayedMemberShip == true){
        membersCount ++;
        this.selected_members.push(element);
      }
    });
    return membersCount;
  }

  onlyNonPayedCheckClicked(){
    this.showOnlyNonPayed = !this.showOnlyNonPayed
    if (this.showOnlyNonPayed){
      this.searched_members = []
      this.members.forEach(element => {
        if (element.hasPayedMemberShip == false){
          this.searched_members.push(element);
        }
      })
    }else{
      this.searched_members = this.members
    }
  }

  isInSavedList(id:number){
    var index = this.saved_list.findIndex( sl => sl == id)
    if (index > -1){ return true}
    else {return false};
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/components/member-mass-payed/member-mass-payed.component.ts